import Swiper, {  } from "swiper";

const swiperEl = {
  swiperContainer: "swiper-cards-banner-vertical",
  swiperCarousel: "swiper-wrapper",
  swiperSlide: "swiper-slide",
};

const breakpoint = window.matchMedia("(min-width: 990px)");

let cardsBannerSwiper;

const breakpointChecker = function (carouselEl) {
  // if larger viewport and multi-row layout needed
  if (breakpoint.matches === true) {
    // clean up old instances and inline styles when available
    if (cardsBannerSwiper !== undefined) {
      cardsBannerSwiper.destroy(true, true);
      carouselEl.style.transform = "translate3D(0,0,0)";
    }
    // or/and do nothing
    return;
    // else if a small viewport and single column layout needed
  } else if (breakpoint.matches === false) {
    // fire small viewport version of swiper
    return enableSwiper();
  }
};

const enableSwiper = function () {
  cardsBannerSwiper = new Swiper("." + swiperEl.swiperContainer, {
    slidesPerView: 1.5,
    spaceBetween: 20,

    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2.5,
        spaceBetween: 30,
      },
      990: {
        slidesPerView: 1,
      },
    },
  });
};

export default function () {
  const swiperContainer = document.querySelector(
    "." + swiperEl.swiperContainer
  );

  if (!swiperContainer) return;

  const swiperCarousel = document.querySelector("." + swiperEl.swiperCarousel);

  breakpoint.addEventListener("change", function (event) {
    breakpointChecker(swiperCarousel);
  });

  breakpointChecker(swiperCarousel);

  window.addEventListener(
    "resize",
    function (event) {
      breakpointChecker(swiperCarousel);
    },
    true
  );
}
